import { HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ConfigurationService } from '@pflegix/config';
import { HttpClientService } from '@pflegix/http-client';
import { ITaskIncludingTrackingInformation, PaginateResultDto } from '@pflegix/types';
import { Observable } from 'rxjs';

enum TaskListWidgetTopic {
  GET_TASKS_FOR_WIDGET = 'GET_TASKS_FOR_WIDGET',
}

@Injectable({ providedIn: 'root' })
export class TaskListWidgetApi {
  private readonly httpClient = inject(HttpClientService);
  private readonly config = inject(ConfigurationService);

  public getTasks(filter: string): Observable<PaginateResultDto<ITaskIncludingTrackingInformation>> {
    const params = new HttpParams()
      .set('page', 1)
      .set('limit', 5)
      .set('filter', `${filter},status$in$new.processing.waiting`)
      .set('sort', '-createdAt');

    return this.httpClient.get<PaginateResultDto<ITaskIncludingTrackingInformation>>(
      `${this.apiUrl}`,
      this.httpClient.buildResilienceConfigForTopic(TaskListWidgetTopic.GET_TASKS_FOR_WIDGET),
      { params }
    );
  }

  private get apiUrl(): string {
    return `${this.config.get('basePflegixApiUrl')}/api/tasks`;
  }
}
